import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const lessThanField = (lessThanControl: AbstractControl): ValidatorFn => {
  const key = 'lessThanField';
  let subscribe = false;

  return (control: AbstractControl): ValidationErrors | null => {
    if (!subscribe) {
      subscribe = true;
      lessThanControl.valueChanges.subscribe(() => {
        control.updateValueAndValidity();
      });
    }

    const value = control.value;

    if (!value) return null;

    if (lessThanControl.value <= value) return { [key]: true };

    return null;
  };
}
